import * as React from 'react';
import {Link,  useNavigate } from 'react-router-dom';
import { useEffect, useState} from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuList from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import EMCLogo from './EMCLogo';
import { ListItemText } from '@mui/material';


const pages = [
            {'item':'Home','link':'/', 'isDivider': false}, 
            {'item':'Recent Activities','link':'/recent', 'isDivider': false}, 
            {'item':'Members','link':'/members', 'isDivider': false},
            {'item':'Dashboards','isDivider': true}, 
            {'item':'Weekly Dashboard','link':'/weekly', 'isDivider': false}, 
            {'item':'Annual Dashboard','link':'/yearly', 'isDivider': false}, 
            {'item':'Challenges','isDivider': true}, 
            {'item':'Summer Challenge','link':'/summer', 'isDivider': false}, 
            {'item':'Autumn Challenge','link':'/autumn', 'isDivider': false}, 
            {'item':'Spring Challenge','link':'/spring', 'isDivider': false}, 
            {'item':'Winter Challenge','link':'/winter', 'isDivider': false}, 
            {'item':'Events','isDivider': true}, 
            {'item':'EMC Events','link':'/emcevents', 'isDivider': false}, 
            {'item':'Public Events','link':'/publicevents', 'isDivider': false}, 
            {'item':'Others','isDivider': true}, 
            {'item':'About','link':'/about', 'isDivider': false}, 
            ];
const settings = [{'item':'Profile', 'link':'/profile'},{'item':'Dashboard', 'link':'/dashboard'}, {'item':'Logout', 'link':'/logout'}];

const EMCAppBar = () => {
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [pic,setPic] = useState("");

  const RenderPage =(page) => {
      return(  page.isDivider ? <Divider/> :
                  <MenuItem key={page.item} onClick={handleCloseNavMenu} component={Link} to={page.link}>
                    <ListItemText>{page.item}</ListItemText>
                  </MenuItem>
      );
  }
  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

    useEffect(() => {
      setPic(localStorage.getItem("pic"));
    },[]);

  const navigate = useNavigate();
  return (
    <AppBar position="static">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'flex' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <MenuList dense="true"
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'block' },
              }}
            >
              {pages.map((page) =>  RenderPage(page)) }
            </MenuList>
          </Box>
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'flex' } }} >
           <EMCLogo/> 
          </Box>

          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar alt="Remy Sharp" src={pic} />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting) => (
                <MenuItem key={setting.item} onClick={()=> { handleCloseUserMenu() ; navigate(setting.link) }}>
                  <Typography textAlign="center">{setting.item}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );

};



export default EMCAppBar;
